import type { Video } from '@/services/videos/types'

export interface AiProposal {
  video: Video
  proposal_id: string
  created_at: string
}

export interface AiPendingProposalsResponse {
  proposals: AiProposal[]
  total_pending: number
  total_pending_per_page: number
  total: number
}

export enum AiVideoStatus {
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export interface AiVideoStatusItem {
  id: number
  status: AiVideoStatus
  video_id?: string
  error_message?: string
  article_url?: string
}

export interface AiVideoStatusResponse {
  items: AiVideoStatusItem[]
}

export interface AiVoice {
  id: string
  name: string
  provider: string
  languageCode: string | null
  languageName: string | null
  gender: string | null
  accent: string | null
  ageGroup: string | null
  engineTypes: string[]
  description: string | null
  previewUrl: string | null
  neural: boolean
  useCase: string | null
}

export interface AiVoicesResponse {
  voices: AiVoice[]
  voiceProvider: string
}

export interface AiLanguageVariant {
  code: string
  label: string
  default: boolean
}

export interface AiLanguageItem {
  language_id: number
  language: string
  variants: AiLanguageVariant[]
}

export interface AiLanguagesResponse {
  items: AiLanguageItem[]
}

export interface GenerateAiVideoForm {
  videoPrompt: string
  prompt?: string
  aspectRatio: string
  voiceId: string | null
  language_id: number | null
  language_variant: string | null
  category: number[]
  duration: number | null
}
